<p>
  Regisztrációdat megerősítetted! Hamarosan tovább irányítunk a
  Bejelentkezéshez. Ha ez mégsem történik meg, kérlek, klikkelj a bal felső
  sarokban a Citydeals logó-ra és onnan elérheted a Bejelentkezés menüpontot!
</p>
